//styles imports
import './App.css';

//general imports
import { useState } from 'react';
import SingleCard from './components/SingleCard/SingleCard';
import { useEffect } from 'react';
import BackSquid from './components/BackSquid/BackSquid';

const cardImages = [
  { "src": "/img/squid_1.jpg", matched: false },
  { "src": "/img/squid_2.jpg", matched: false },
  { "src": "/img/squid_3.jpg", matched: false },
  { "src": "/img/squid_4.jpg", matched: false },
  { "src": "/img/squid_5.jpg", matched: false },
  { "src": "/img/squid_6.jpg", matched: false }
]

function App() {

  const [cards, setCards] = useState([])
  const [turns, setTurns] = useState(0)
  const [choiceOne, setChoiceOne] = useState(null)
  const [choiceTwo, setChoiceTwo] = useState(null)
  const [disabled, setDisabled] = useState(false)

  //shuffle the cards
  const shuffleCards = () => {
    const shuffledCards = [...cardImages, ...cardImages]
      .sort(() => Math.random() - 0.5 )
      .map((card) => ({ ...card, id: Math.random() }))

    setChoiceOne(null)
    setChoiceTwo(null)
    setCards(shuffledCards)
    setTurns(0)
  }

  //handle a single choice
  const handleChoice = (card) => {
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card)
  }

  //compare 2 choices using useEffect
  useEffect(() => {
    if(choiceOne && choiceTwo) {
      setDisabled(true)
      if(choiceOne.src === choiceTwo.src) {
        setCards(prevCards => {
          return prevCards.map(card => {
            if (card.src === choiceOne.src) {
              return {...card, matched: true}
            } else {
              return card
            }
          })
        })
        resetTurn()
      } else {
        setTimeout(() => resetTurn(), 750) 
      }

    }

  },[choiceOne,choiceTwo])

  console.log(cards)

  //choice reset and increment turns
  const resetTurn = () => {
    setChoiceOne(null)
    setChoiceTwo(null)
    setTurns(prevTurns => prevTurns + 1)
    setDisabled(false)
  }

  //auto start game on load
  useEffect(() => {
    shuffleCards()
  },[])

  return (
    <div className="App">
      <BackSquid />
      <h1>Squid Cards</h1>
      <p className="description">Match each Squid Card with its correct pair. If a player fails to match a card, the player will be eliminated. Pressing "New Game" will restart the game.</p>
      <button onClick={shuffleCards}>New Game</button>

      <div className="card-grid">
        {cards.map(card => (
        <SingleCard 
          card={card}  
          key={card.id}
          handleChoice={handleChoice}
          flipped={card === choiceOne || card === choiceTwo || card.matched}
          disabled={disabled}
        />
        ))}
      </div>
      <h4>Turns: {turns}</h4>
    </div>
  );
}

export default App;
